import React from "react";
import "./ourSpecialties.scss";
import { OurSpecialtiesMenu } from "../../../constants/Specialties";
import Button from "../../Common/Button/Button";
import Popup from "../../Common/Popup/Popup";
import { useState } from "react";

const OurSpecialties = () => {
  return (
    <section id="our-specialities-wrapper">
      <h2 className="heading">
        Our <span>Specialties</span>
      </h2>
      <div className="our-specialties">
        {OurSpecialtiesMenu?.map((item) => {
          return (
            <>
              <div className="specialties">
                <div class="flip-card-inner">
                  <div class="card-front">
                    <h6>{item?.id}</h6>
                    <div className="image">
                      <img src={item?.image} alt="" />
                      <p>{item?.name}</p>
                    </div>
                  </div>
                  <div class="card-back">
                    <p>
                     {item?.title}
                    </p>
                  </div>
                </div>
              </div>
            </>
          );
        })}
      </div>
    </section>
  );
};

export default OurSpecialties;
